import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { MbCountriesNoAccountAdapter } from '../connectors/quote-info'
import { MB_COUNTRIES_NO_ACCOUNT_NORMALIZER } from '../connectors/quote-info/mb-convertors'
import { pluck } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class MbOccCountriesNoAccountAdapter implements MbCountriesNoAccountAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load () {
    return this.http.get(this.getEndpoint()).pipe(
      pluck('countries'),
      this.converter.pipeable(MB_COUNTRIES_NO_ACCOUNT_NORMALIZER)
    )
  }

  protected getEndpoint () {
    return this.occEndpoints.buildUrl(
      'countriesWithNoAccount'
    )
  }
}
